import {RouteInterface} from "../interfaces/RouteInterface";
import {Login} from "../features/public/Login/Login";
import {RouteDefine} from "./RouteDefine";
import ResetPassword from "../features/public/ResetPassword/ResetPassword";
import ForgotPassword from "../features/public/ResetPassword/ForgotPassword";
import {AdminLogin} from "../features/public/AdminLogin/AdminLogin";
import RegisterFromEconomic from "../features/public/RegisterFromEconomic";

export const authRoutes: Array<RouteInterface> = [
    {path: RouteDefine.login, Component: Login},
    {path: RouteDefine.adminLogin, Component: AdminLogin},
    {path: RouteDefine.resetPassword, Component: ResetPassword},
    {path: RouteDefine.forgotPassword, Component: ForgotPassword},
    {path: RouteDefine.register, Component: RegisterFromEconomic},
];
